<template>
  <v-card
    class="outlined-card summary-half-card d-flex flex-column"
    elevation="0"
  >
    <div class="d-flex align-center stat-body flex-grow-1">
      <v-avatar :color="avatarColor" class="stat-avatar mr-4 flex-shrink-0">
        <img v-if="imgSrc" :src="imgSrc" class="stat-img" alt="icon">
        <v-icon v-else :color="iconColor" class="stat-icon">{{ icon }}</v-icon>
      </v-avatar>
      <div>
        <div class="font-weight-bold stat-number" :style="{ color: numberColor }">{{ numberValue | formatNumber }}</div>
        <div class="mt-1 stat-label">{{ label }}</div>
      </div>
    </div>
    <v-divider class="mx-4"></v-divider>
    <div class="d-flex align-center justify-space-between stat-footer" style="cursor: pointer;" @click="$emit('click-action')">
      <div class="d-flex align-center stat-footer-text" style="color: #3a5bb8;">
        <span class="font-weight-medium">{{ footerText }}</span>
      </div>
      <v-btn icon elevation="0" class="chevron-btn">
        <v-icon size="20" color="#3a5bb8">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    avatarColor: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: ''
    },
    numberColor: {
      type: String,
      default: '#202A63'
    },
    numberValue: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      required: true
    },
    footerText: {
      type: String,
      required: true
    }
  },
  filters: {
    formatNumber(value) {
      if (!value) return 0
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style scoped>
.outlined-card {
  border: 1px solid #dde3f0 !important;
  border-radius: 16px !important;
  box-shadow: 0 2px 12px rgba(25, 50, 120, 0.08) !important;
}

.summary-half-card {
  flex: 1 1 50%;
  min-width: 0;
}

.stat-body {
  padding: 20px;
}

::v-deep .stat-avatar {
  width: 84px !important;
  height: 84px !important;
  min-width: 84px !important;
}
::v-deep .stat-icon {
  font-size: 48px !important;
}

.stat-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.1;
}

.stat-label {
  font-size: 16px;
  color: #757575;
}

.stat-footer {
  padding: 12px 16px;
}

.stat-footer-text {
  font-size: 14px;
}

.chevron-btn {
  background-color: #E8EDF7 !important;
  border-radius: 6px !important;
  width: 24px !important;
  height: 24px !important;
}

/* ── Responsive ── */
@media (max-width: 1300px) {
  .stat-body {
    padding: 14px 16px;
  }

  ::v-deep .stat-avatar {
    width: 60px !important;
    height: 60px !important;
    min-width: 60px !important;
  }
  ::v-deep .stat-icon {
    font-size: 32px !important;
  }

  .stat-number {
    font-size: 34px;
  }

  .stat-label {
    font-size: 14px;
  }

  .stat-footer {
    padding: 8px 16px;
  }

  .stat-footer-text {
    font-size: 13px;
  }
}

@media (max-width: 960px) {
  ::v-deep .stat-avatar {
    width: 72px !important;
    height: 72px !important;
    min-width: 72px !important;
  }
  ::v-deep .stat-icon {
    font-size: 40px !important;
  }

  .stat-number {
    font-size: 40px;
  }

  .stat-body {
    padding: 16px 20px;
  }

  .stat-footer {
    padding: 10px 20px;
  }
}

@media (max-width: 768px) {
  ::v-deep .stat-avatar {
    width: 64px !important;
    height: 64px !important;
    min-width: 64px !important;
  }
  ::v-deep .stat-icon {
    font-size: 36px !important;
  }

  .stat-number {
    font-size: 36px;
  }

  .stat-body {
    padding: 14px 16px;
  }

  .stat-footer {
    padding: 10px 16px;
  }

  .stat-footer-text {
    font-size: 13px;
  }
}

@media (max-width: 600px) {
  .stat-number {
    font-size: 32px;
  }

  ::v-deep .stat-avatar {
    width: 56px !important;
    height: 56px !important;
    min-width: 56px !important;
  }
  ::v-deep .stat-icon {
    font-size: 30px !important;
  }
}
</style>
